import getQueryString from 'querystring';
import Resources from '../../helpers/resources';
import { setUserRole } from '../user/user-actions';
import {
  userRoles,
  timestamps
} from '../../helpers/constants';
import { activateError } from '../error-handling/error-handling-actions';
import { getStartTimeOnline } from './mle-utils';
import { getLocale } from '../../helpers/utils';

export const QUERY_STRING_ACQUIRED = 'QUERY_STRING_ACQUIRED';
export const INIT_MLE_DATA_ACQUIRED = 'INIT_MLE_DATA_ACQUIRED';
export const INIT_MLE_DATA_REQUESTED = 'INIT_MLE_DATA_REQUESTED';
export const INIT_MLE_DATA_FAILED = 'INIT_MLE_DATA_FAILED';

export const TIMESTAMP_ENTER = 'TIMESTAMP_ENTER';
export const TIMESTAMP_LEAVE = 'TIMESTAMP_LEAVE';
export const TIMESTAMP_CHECK = 'TIMESTAMP_CHECK';
export const TIMESTAMP_COMPLETE = 'TIMESTAMP_COMPLETE';

export const COMPONENT_ENABLED_SPINNER = 'COMPONENT_ENABLED_SPINNER';
export const COMPONENT_DISABLED_SPINNER = 'COMPONENT_DISABLED_SPINNER';

export const DEFAULT_ASSIGNMENT_SPINNER = 'DEFAULT_ASSIGNMENT_SPINNER';
export const ACTIVITY_RENDER_SPINNER = 'ACTIVITY_RENDER_SPINNER';
export const LEAVE_ACTIVITY_SPINNER = 'LEAVE_ACTIVITY_SPINNER';

export const START_TIME_RECORDED = 'START_TIME_RECORDED';

export const enableSpinner = item => ({
  type: COMPONENT_ENABLED_SPINNER,
  item
});

export const disableSpinner = item => ({
  type: COMPONENT_DISABLED_SPINNER,
  item
});

export const queryString = () => {
  const queryParams = window.location.search;
  const query = queryParams.replace('?', '');
  return getQueryString.parse(query);
};

export const acquireQueryString = () => (dispatch) => {
  const {
    girlId, userId, isPreview, locale, authToken, newContent, keypadPreset, assignmentId = 0, classId
  } = queryString();
  dispatch(setUserRole(userId && isPreview !== 'true' ? userRoles.TEACHER : userRoles.STUDENT));
  dispatch({
    type: QUERY_STRING_ACQUIRED,
    payload: {
      girlId,
      userId,
      isPreview: isPreview === 'true',
      locale,
      authToken,
      newContent,
      keypadPreset,
      assignmentId,
      classId
    }
  });
};

const acquireInitMleDataRequested = () => ({
  type: INIT_MLE_DATA_REQUESTED
});

const acquireInitMleDataFailed = () => ({
  type: INIT_MLE_DATA_FAILED
});

export const acquireInitMleData = () => async (dispatch, getState) => {
  const { queryStringReducer: { userId, girlId, assignmentId, classId } } = getState();

  dispatch(acquireInitMleDataRequested());

  try {
    const locale = getLocale();
    const body = {
      assignmentId,
      classId
    };
    if (locale) {
      body.locale = locale;
    }
    const response = await Resources[userId ? 'getTeacherModules' : 'getStudentModules']
      .post({
        userId,
        girlId
      })
      .withBody(body)
      .send();
    if (response.data) {
      dispatch({
        type: INIT_MLE_DATA_ACQUIRED,
        payload: response.data
      });
    } else {
      dispatch(acquireInitMleDataFailed());
      dispatch(activateError(response.status));
    }
  } catch (err) {
    dispatch(acquireInitMleDataFailed());
    dispatch(activateError(err));
    throw err;
  }
};

export const recordTime = verb => async (dispatch, getState) => {
  const { userRole } = getState().userReducer;
  const { isPreview, userId, girlId } = queryString();
  let eventId = null;

  switch (verb) {
    case TIMESTAMP_ENTER: {
      if (isPreview) {
        eventId = timestamps.TEACHER_ENTERED_PREVIEW;
      } else if (userRole === userRoles.STUDENT) {
        eventId = timestamps.STUDENT_ENTERED;
        // record landed time
        dispatch({
          type: START_TIME_RECORDED,
          startTime: getStartTimeOnline()
        });
      } else if (userRole === userRoles.TEACHER) {
        eventId = timestamps.TEACHER_ENTERED;
      }
      break;
    }
    case TIMESTAMP_LEAVE: {
      if (isPreview) {
        eventId = timestamps.TEACHER_LEFT_PREVIEW;
      } else if (userRole === userRoles.STUDENT) {
        eventId = timestamps.STUDENT_LEFT;
      } else if (userRole === userRoles.TEACHER) {
        eventId = timestamps.TEACHER_LEFT;
      }
      break;
    }
    case TIMESTAMP_CHECK: {
      if (isPreview || userId) {
        break;
      }
      eventId = timestamps.STUDENT_CHECKED_ACTIVITY;
      break;
    }
    case TIMESTAMP_COMPLETE: {
      if (isPreview || userId) {
        break;
      }
      eventId = timestamps.STUDENT_COMPLETED_ACTIVITY;
      break;
    }
    default: {
      break;
    }
  }

  try {
    const response = await Resources.events
      .post()
      .withBody({
        eventId,
        resourceId: girlId
      })
      .send();

    if (response.status === 200 || response.status === 204) {
      // eslint-disable-next-line no-console
      // console.log(`Time recorded - ${eventId}`);
    } else {
      // eslint-disable-next-line no-console
      // console.log('Timestamp error');
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    // console.log(`Timestamp error - ${err}`);
  }
};

export const registerDefaultAssign = ({
  teacherUserProfileId,
  girlId }) => async (dispatch) => {
  enableSpinner(DEFAULT_ASSIGNMENT_SPINNER);
  try {
    const response = await Resources.assignDefault
      .post()
      .withBody({
        teacherUserProfileId,
        girlId
      })
      .send();

    const { data, status } = response;

    if (status >= 200 && status < 300) {
      disableSpinner(DEFAULT_ASSIGNMENT_SPINNER);
    } else {
      disableSpinner(DEFAULT_ASSIGNMENT_SPINNER);
      dispatch(activateError(data.status));
    }
  } catch (err) {
    disableSpinner(DEFAULT_ASSIGNMENT_SPINNER);
    dispatch(activateError(err));
  }
};
